export const ACCOUNT_MAPPING_ACTIONS_COLUMN_WIDTH_PX = 350;
export const ACCOUNT_MAPPING_TYPE_COLUMN_WIDTH_PX = 250;
export const ACCOUNT_MAPPING_NAME_MIN_WIDTH_PX = 180;
export const ACCOUNT_MAPPING_PROVIDER_TYPE_COLUMN_WIDTH_PX = 180;

interface TypeReviewGridTemplateParams {
    isTypeReview: boolean;
    includeActions: boolean;
}

export function accountMappingGridTemplateColumns({
    isTypeReview,
    includeActions,
}: TypeReviewGridTemplateParams): string {
    const nameColumn = `minmax(${ACCOUNT_MAPPING_NAME_MIN_WIDTH_PX}px, 1fr)`;
    const providerTypeColumn = isTypeReview
        ? `${ACCOUNT_MAPPING_PROVIDER_TYPE_COLUMN_WIDTH_PX}px`
        : "";
    const typeColumn = isTypeReview
        ? "1fr"
        : `${ACCOUNT_MAPPING_TYPE_COLUMN_WIDTH_PX}px`;
    const kickAccountColumn = isTypeReview ? "" : nameColumn;
    const actionsColumn = includeActions
        ? `${ACCOUNT_MAPPING_ACTIONS_COLUMN_WIDTH_PX}px`
        : "";

    return [
        nameColumn,
        providerTypeColumn,
        kickAccountColumn,
        typeColumn,
        actionsColumn,
    ]
        .filter((column) => column !== "")
        .join(" ");
}
